/**
 * AgentSyncHint — says why an agent's details could not be synced from its source.
 * Renders nothing when the agent was found, or when its source has no agent directory.
 */

const HINTS = {
  unavailable: {
    label: 'Name not synced yet',
    title: "The source could not be reached when this agent's conversations came in. The name is filled in with the next one.",
  },
  not_found: {
    label: 'Not found in source',
    title: 'The source has no agent with this ID. It may have been deleted there.',
  },
  org_mismatch: {
    label: 'Not in this organisation',
    title: 'This agent ID belongs to another organisation, so its details are withheld.',
  },
};

const AgentSyncHint = ({ status }) => {
  const hint = HINTS[status];
  if (!hint) return null;
  return (
    <span className="text-[10px] px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 whitespace-nowrap" title={hint.title}>
      {hint.label}
    </span>
  );
};

export default AgentSyncHint;
